import styled from 'styled-components';
import { getColor } from 'core/utils/Styles';
import { resetBtn } from 'styled-manila';

export const Row = styled.div`
	display: flex;
	align-items: center;
	margin-top: 20px;
`;

export const Button = styled.button`
	${resetBtn}
	padding: 12px 16px;
	
	background-color: ${props => props.invert ? getColor('white') : getColor('gray')};
	color: ${props => props.invert ? getColor('black') : getColor('white')};
	border-radius: 0;
	border: ${props => props.invert ? `2px solid ${getColor('gray')}`: "none"};
	text-decoration: none;
	font-weight: 700;
	font-size: 16px;
	flex: 1 0 50%;
	height: ${props => props.height ? props.height : "44px"};
	line-height: 20px;

	&:hover, &:focus {
		text-decoration: none;
		background-color: ${props => props.invert ? getColor('gray') : getColor('limedHover')};
		color: ${getColor('white')};
	}

	&[disabled] {
		cursor: not-allowed;
		opacity: 0.8;
		display: flex;
		align-items: center;
		justify-content: center;
		/* stylelint-disable */
		svg {
			width: 18px;
			height: 18px;
		}
		/* stylelint-enable */
	}
`;

export const Forgot = styled.button`
	${resetBtn}
	color: ${getColor('limedSpruceGray')};
	font-size: 14px;
	flex: 1 0 50%;

	&:hover, &:focus {
		color: ${getColor('limedHover')};
	}

	&[disabled] {
		cursor: not-allowed;
		opacity: 0.8;
	}
`;
